<div class="flex flex-col h-full w-full">
  <app-page-header>
    Tasks
    <div class="flex flex-row gap-4 whitespace-nowrap">
      <!-- BCF Buttons auskommentiert bis auf Weiteres -->
      <!--      <bic-button [text]="'BCF Import'" [textColor]="'black'" buttonType="white"  [iconLeft]="faArrowDownToBracket" (onClick)="bcfUpload.click()" *ngIf="!selectionActivated"></bic-button>-->
      <!--      <bic-button [text]="'BCF Export'" [textColor]="'black'" buttonType="white"  [iconLeft]="faArrowUpFromBracket" (onClick)="selectionActivated = true" *ngIf="!selectionActivated"></bic-button>-->

      <!--      <bic-button [text]="'Abbrechen'" [textColor]="'black'" buttonType="white"  (onClick)="selectionActivated = false" *ngIf="selectionActivated"></bic-button>-->
      <!--      <bic-button [text]="'BCF Export'" [textColor]="'black'" buttonType="white"  [iconLeft]="faArrowUpFromBracket" [disabled]="selec" (onClick)="board.emitSelectedTasks()" *ngIf="activeLinkIndex == viewType.BOARD && selectionActivated"></bic-button>-->


      <!--      <bic-button [bicDropdownTrigger]="dropdownBcf" [text]="'BCF Tasks'" [textColor]="'black'" buttonType="white"  [iconLeft]="faIfc"></bic-button>-->
      <!--      <bic-dropdown #dropdownBcf [dropdownPlacement]="'bottom-start'">-->
      <!--        <bic-dropdown-element (onClick)="bcfUpload.click()">-->
      <!--          <div class="flex flex-row text-sm gap-3 text-gray-700">-->
      <!--            <fa-icon class="text-gray-700" [icon]="faArrowDownToBracket"></fa-icon>-->
      <!--            <span>BCF Import</span>-->
      <!--          </div>-->
      <!--        </bic-dropdown-element>-->
      <!--        <bic-dropdown-element>-->
      <!--          <div class="flex flex-row text-sm gap-3 text-gray-700">-->
      <!--            <fa-icon class="text-gray-700" [icon]="faArrowUpFromBracket"></fa-icon>-->
      <!--            <span>BCF Export</span>-->
<!--          </div>-->
<!--        </bic-dropdown-element>-->
<!--      </bic-dropdown>-->
      <div class="w-full">
        <!--bic-input (input)="search($event)" [iconStart]="faSearch" [placeholder]="'Task suchen...'"></bic-input-->
        <form class="flex items-center">

          <label class="sr-only" for="simple-search">Task suchen</label>
          <div class="relative w-full">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-500"
                   viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      fill-rule="evenodd"/>
              </svg>
            </div>
            <input
              class="border block w-full pl-10 py-1.5 px-3 bg-gray-50 border-gray-300 text-gray font-normal text-sm rounded-lg ring-green focus:ring-gray-300 focus:border-gray-300 "
              id="simple-search"
              (input)="search($event)"
              [value]="searchAndFilter.search"
              placeholder="Task suchen..."
              type="text">

          </div>
        </form>
      </div>

      <app-bic-filter #taskFilter (filtersChange)="onFilterChange($event)" [filtersConfig]="filterConfig">
      </app-bic-filter>

      <!-- Sortierung wie in den myCheck-Übersichten: pro Kriterium ein Pfeil-Paar für beide
           Richtungen, das Button-Label bleibt statisch. -->
      <bic-button [bicDropdownTrigger]="sortDropdown" buttonType="white" tooltip="Sortieren" tooltipDirection="bottom">
        <fa-icon [icon]="faArrowDownWideShort" iconLeft></fa-icon>
        <span class="bic-btn-label--compact">Sortieren</span>
      </bic-button>
      <bic-dropdown #sortDropdown [dropdownPlacement]="'bottom-end'" class="contents">
        <div class="w-[200px] py-1">
          @for (opt of sortFieldOptions; track opt.field) {
            <div class="flex flex-row items-center justify-between gap-3 px-3 py-1 hover:bg-gray-50">
              <span class="text-sm text-gray-900">{{ opt.label }}</span>
              <div class="flex flex-row items-center gap-0.5">
                <button (click)="applySort(opt.field, 'asc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'asc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.ascLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowUpWideShort" class="text-sm"></fa-icon>
                </button>
                <button (click)="applySort(opt.field, 'desc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'desc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.descLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowDownWideShort" class="text-sm"></fa-icon>
                </button>
              </div>
            </div>
          }
        </div>
      </bic-dropdown>
    </div>
  </app-page-header>
  <!--  <div class="flex flex-row justify-start items-center text-gray-400 py-2 px-4">-->
<!--    <button (click)="changeViewType(viewType.LIST)" [class.active]="activeLinkIndex == viewType.LIST" class="mr-4">Tabelle</button>-->
<!--    <button (click)="changeViewType(viewType.BOARD)" [class.active]="activeLinkIndex == viewType.BOARD">Board</button>-->
<!--  </div>-->
  <!--  <div class="h-1 bg-gray-400 shadow"></div>-->
<!--  <div class="h-4"></div>-->
  <div class="flex flex-grow h-full min-w-0 overflow-hidden">
    <div class="flex flex-grow p-6 min-w-0">
      @if (activeLinkIndex == viewType.LIST) {
        <app-task-list #applist (exportBCFClicked)="exportBCF($event)"
                       class="w-full"></app-task-list>
      }
      @if (activeLinkIndex == viewType.BOARD) {
        <app-task-board #board (exportBCFClicked)="exportBCF($event)" (exportBCFsClicked)="exportBCFs($event)"
                        (selectedTasksChanged)="exportBCFs($event)"
                        (resetSearchClicked)="resetSearch()"
                        [searchAndFilter]="searchAndFilter" [selectionMode]="selectionActivated"
                        [sortField]="sortField" [sortDirection]="sortDirection"
                        (assignedUsersChanged)="onAssignedUsersChanged($event)"
                        class="w-full"></app-task-board>
      }
    </div>
  </div>
</div>
